import { ExclamationTriangleIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/react/16/solid'
import clsx from 'clsx'
import { Badge, Scroll } from '@criteria-labs/react'
import { ConsoleTab } from '../console/ConsoleLayout'
import { SourceRange, SpectralIssue } from './Issue'
import { useAllIssues } from './useAllIssues'

export function IssueNavigatorPanelHeader({ selected, onClick }: { selected: boolean; onClick?: () => void }) {
  const issues = useAllIssues()

  return (
    <ConsoleTab selected={selected} onClick={onClick}>
      <span className="flex items-center text-sm/6 font-medium text-zinc-950 dark:text-white">Issues</span>
      {issues.length > 0 && <Badge color="yellow">{issues.length}</Badge>}
    </ConsoleTab>
  )
}

export function IssueNavigatorPanelBody({
  onGoTo
}: {
  onGoTo: (destination: { filePath: string; textSelection: SourceRange }) => void
}) {
  const issues = useAllIssues()

  return (
    <Scroll>
      <ul className={clsx(['divide-y divide-zinc-950/10 dark:divide-white/10'])}>
        {issues.map((issue) => (
          <li key={issue.id}>
            <button
              type="button"
              className={clsx([
                'flex w-full items-center px-4 py-1.5',

                'hover:bg-zinc-100 active:bg-zinc-200 dark:hover:bg-zinc-900 dark:active:bg-zinc-800',

                // Icon
                '[&>[data-slot=icon]]:mr-2 [&>[data-slot=icon]]:size-4'
              ])}
              onClick={
                issue instanceof SpectralIssue
                  ? () => {
                      onGoTo({ filePath: issue.filePath, textSelection: issue.range })
                    }
                  : undefined
              }
            >
              {issue.severity === 'notice' && <InformationCircleIcon className="text-zinc-400 dark:text-zinc-600" />}
              {issue.severity === 'warning' && <ExclamationTriangleIcon className="text-yellow-500" />}
              {issue.severity === 'error' && <XCircleIcon className="text-red-500" />}
              <span className="text-xs text-zinc-950 dark:text-white">{issue.detail}</span>
              {issue instanceof SpectralIssue && (
                <em className="ml-1 text-xs text-zinc-400">({issue.spectralDiagnostic.code})</em>
              )}
              <span className="flex-1 flex-grow" />
              {issue instanceof SpectralIssue && (
                <em className="text-xs text-zinc-400">
                  {issue.filePath.slice(1)} (line {issue.spectralDiagnostic.range.start.line})
                </em>
              )}
            </button>
          </li>
        ))}
      </ul>
    </Scroll>
  )
}
